import React from 'react'
import { useLocation } from 'react-router-dom'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import './MinigamesListPage.scss'

const MinigamesListPage = () => {
	const location = useLocation()

	const pageWidget = location.pathname.includes('/mini-games')
		? WIDGETS.minigamesPage
		: location.pathname.includes('/quiz')
			? WIDGETS.quiz
			: WIDGETS.matchx

	return (
		<div className="main-content mini-games-list-page">
			<GamificationBlock
				key={pageWidget.url}
				domId={pageWidget.domId}
				url={pageWidget.url}
				fit="content"
				className="gamification-block--content"
			/>
		</div>
	)
}

export default MinigamesListPage
